import React from 'react';
import { socialPosts } from '../data/demandData';
const statusStyles: Record<string, string> = {
  Published: 'bg-forest/10 text-forest',
  Scheduled: 'bg-[#BB5E40]/12 text-[#94452E]',
  Draft: 'bg-ink/8 text-ink/55'
};
export function DemandSocial() {
  const published = socialPosts.filter(post => post.status === 'Published');
  const reach = published.reduce((sum, post) => sum + post.reach, 0);
  const clicks = published.reduce((sum, post) => sum + post.clicks, 0);
  const engagement = published.length > 0 ? published.reduce((sum, post) => sum + post.engagement, 0) / published.length : 0;
  return <section aria-labelledby="social-heading" data-id="element-1211" data-mp="388rua0yrjw1f">
      <h2 id="social-heading" className="font-display text-2xl font-medium tracking-tight" data-id="element-1212" data-mp="387gqi15bioab">Social</h2>
      <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-ink/60" data-id="element-1213" data-mp="338ne6c1rp3bq">
        Organic posts supporting recovery inventory, including the monthly Manymoons partnership push.
      </p>

      <div className="mt-5 grid gap-3 sm:grid-cols-3" data-id="element-1214" data-mp="2ubwmscy5ucnh">
        <Tile label="Reach" value={`${(reach / 1000).toFixed(0)}K`} detail="Across published posts" data-id="element-1215" data-mp="3l7o6hkzcsrgd" />
        <Tile label="Avg. engagement" value={`${engagement.toFixed(1)}%`} detail="Likes, saves, and comments" data-id="element-1216" data-mp="3pzpnfk7gv6cq" />
        <Tile label="Clicks to inventory" value={clicks.toLocaleString('en-US')} detail="Traffic driven to listings" data-id="element-1217" data-mp="3bb2w0k4keo55" />
      </div>

      <div className="mt-5 space-y-3" data-id="element-1218" data-mp="3g6s2z8iwz7bh">
        {socialPosts.map(post => <article key={post.id} className="flex flex-col gap-4 rounded-2xl border border-ink/10 bg-paper p-5 shadow-sm sm:flex-row sm:items-center sm:justify-between" data-id="element-1219" data-mp="7tkpqh4fxp6u">
            <div className="min-w-0" data-id="element-1220" data-mp="3uyip8fde58x2">
              <div className="flex flex-wrap items-center gap-2.5" data-id="element-1221" data-mp="3uxhgihjukyii">
                <span className="text-sm font-semibold" data-id="element-1222" data-mp="2sx3e8r5pwiy">{post.channel}</span>
                <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${statusStyles[post.status]}`} data-id="element-1223" data-mp="2ji2hl882vwkr">{post.status}</span>
                <span className="text-xs text-ink/50" data-id="element-1224" data-mp="2nlqrvyo3h69p">{post.posted}</span>
              </div>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/70" data-id="element-1225" data-mp="u05d0iwlpjz6">{post.caption}</p>
            </div>
            {post.status === 'Published' ? <dl className="flex shrink-0 gap-8 text-sm" data-id="element-1226" data-mp="kbdl2arjizo9">
                <Metric label="Reach" value={post.reach.toLocaleString('en-US')} data-id="element-1227" data-mp="k9kf6xor4jhb" />
                <Metric label="Engagement" value={`${post.engagement}%`} data-id="element-1228" data-mp="fc10jwo564ou" />
                <Metric label="Clicks" value={post.clicks.toLocaleString('en-US')} data-id="element-1229" data-mp="bc0cdkb8qf4l" />
              </dl> : <button type="button" className="shrink-0 rounded-full border border-ink/15 px-4 py-2 text-xs font-semibold text-ink/70 transition-colors hover:bg-cream/60" data-id="element-1230" data-mp="6aazs08ddtee">
                {post.status === 'Scheduled' ? 'Edit schedule' : 'Finish draft'}
              </button>}
          </article>)}
      </div>
    </section>;
}
function Tile({
  label,
  value,
  detail
}: {
  label: string;
  value: string;
  detail: string;
}) {
  return <div className="rounded-2xl border border-ink/10 bg-paper p-4" data-id="element-1231" data-mp="1z8zpukav923a">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-1232" data-mp="1z6nbeh4bh9uz">{label}</p>
      <p className="mt-1.5 font-display text-2xl font-semibold tracking-tight" data-id="element-1233" data-mp="2388kdrdqd3zw">{value}</p>
      <p className="mt-1 text-xs text-ink/50" data-id="element-1234" data-mp="281tlhsamee3b">{detail}</p>
    </div>;
}
function Metric({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div data-id="element-1235" data-mp="1gadt1hmdtx56">
      <dt className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-1236" data-mp="1gax90ssh2bgk">{label}</dt>
      <dd className="mt-0.5 font-semibold tabular-nums text-ink" data-id="element-1237" data-mp="1kapbqov6pne0">{value}</dd>
    </div>;
}